import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export function QueryFeedback({ state, title, description, onRetry, onClear }: {
  state: 'loading' | 'error' | 'empty' | 'filtered-empty';
  title: string;
  description?: string;
  onRetry?: () => void;
  onClear?: () => void;
}) {
  return <div role={state === 'error' ? 'alert' : 'status'}
    className="space-y-3 rounded-md border border-dashed p-4 text-sm">
    <p className={state === 'error' ? 'font-medium text-destructive' : 'font-medium'}>{title}</p>
    {description && <p className="text-muted-foreground">{description}</p>}
    {state === 'loading' && <Skeleton aria-hidden className="h-16 w-full" />}
    {state === 'error' && onRetry && <Button type="button" variant="outline" onClick={onRetry}>Try again</Button>}
    {state === 'filtered-empty' && onClear && <Button type="button" variant="outline" onClick={onClear}>Clear filters</Button>}
  </div>;
}
export function ListPagination({ offset, pageSize, total, pending, onChange, label }: {
  offset: number; pageSize: number; total: number; pending: boolean;
  onChange: (offset: number) => void; label: string;
}) {
  return <nav aria-label={label} className="mt-4 flex flex-wrap items-center justify-between gap-3">
    <p role="status" className="text-muted-foreground text-sm">
      {total === 0 ? '0 results' : `${offset + 1}–${Math.min(offset + pageSize, total)} of ${total}`}
    </p>
    <div className="flex gap-2">
      <Button type="button" variant="outline" disabled={pending || offset === 0}
        onClick={() => onChange(Math.max(0, offset - pageSize))}>Previous</Button>
      <Button type="button" variant="outline" disabled={pending || offset + pageSize >= total}
        onClick={() => onChange(offset + pageSize)}>Next</Button>
    </div>
  </nav>;
}
